<script src="http://res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
<template>
  <el-form class="login-form" status-icon :rules="loginRules" ref="loginForm" :model="loginForm" label-width="0">
    <el-form-item prop="username" style="margin-bottom:40px;">
      <el-input class="login-sub" size="small" @keyup.enter.native="handleLogin" v-model="loginForm.username" auto-complete="off" placeholder="请输入账号">
        <i slot="prefix" class="icon-yonghu"></i>
      </el-input>
    </el-form-item>
    <el-form-item prop="password" style="margin-bottom:40px;height:40px;">
      <el-input class="login-sub" size="small" @keyup.enter.native="handleLogin" :type="passwordType" v-model="loginForm.password" auto-complete="off" placeholder="密码">
        <i class="el-icon-view el-input__icon" slot="suffix" @click="showPassword"></i>
        <i slot="prefix" class="icon-mima"></i>
      </el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" size="small" @click.native.prevent="handleLogin" class="login-submit">登录</el-button>
    </el-form-item>
  </el-form>
</template>
<script>
import { getList } from '@/api/health/test'
import { selectOne } from '@/api/sys/user'
import { loginByUsername } from '@/api/login'

export default {
  name: 'UserLogin',
  loginuser: '',
  setloginuser(loginuser) {
    this.loginuser = loginuser
  },
  data() {
    return {
      loginForm: {
        username: '',
        password: '',
        requestHeadUrl: 'https://dbadmin.dbzdjk.com',
        type: false,
        appLink: ''
      },
      loginRules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 5, message: '密码长度最少为5位', trigger: 'blur' }
        ]
      },
      passwordType: 'password',
      params: {
        username: ''
      }
    }
  },
  created() {},
  methods: {
    showPassword() {
      this.passwordType === '' ? (this.passwordType = 'password') : (this.passwordType = '')
    },
    handleLogin() {
      console.log(this.loginForm)
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          loginByUsername(this.loginForm.username, this.loginForm.password).then(res => {
            if (!res || res.success === false || !res.data) {
              return Promise.reject(res)
            }
            this.$store.commit('SET_TOKEN', res.data.token)
            this.$store.commit('SET_USER_INFO', res.data)
            // this.$router.push({ path: '/' })
            this.loginuser = this.loginForm.username // 用户名
            this.$myUser.setloginuser(this.loginForm.username)
            window.localStorage.setItem('username', this.loginForm.username)
            this.params.username = this.$myUser.loginuser
            return selectOne(this.params)
              .then(res => {
                window.localStorage.setItem('channel', res.data.channel)
                window.localStorage.setItem('username', res.data.username)
                window.localStorage.setItem('name', res.data.name)
                window.localStorage.setItem('pcUserId', res.data.id)
              })
              .then(res => {
                this.$router.push({ path: '/selectInstitution' })
              })
          }).catch(err => {
            this.$alert((err && err.msg) || '登录失败，请稍后重试', '登录提示', {
              confirmButtonText: '确定',
              type: 'error'
            }).catch(() => {})
          })
        }
      })
    },
    onLoad() {
      getList().then(res => {
        console.log(res)
        this.appLink = res.data
        location.href = res.data
      })
    }
  }
}
</script>

<style scoped>
  .login-form .login-sub{
    background-color: light-dark(rgb(232, 240, 254), rgba(70, 90, 126, 0.4)) !important;
  }
</style>
